<template>
    <div class="main">
        <div class="main-header container">
            <ainak-header/>
        </div>
        <div class="main-content container">
            <mobile-app-content/>
        </div>
        <div class="main-footer">
            <ainak-footer/>
        </div>
    </div>
</template>

<script>
    import MobileAppContent from "@/components/SubPages/MobileAppContent.vue";
    import AinakHeader from "../components/AinakHeader";
    import AinakFooter from "../components/AinakFooter";
    export default {
        name: "MobileApp",
        components: {
            AinakFooter,
            AinakHeader,
            MobileAppContent
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
         width: 100%;
         height: 100%;
         top: 0;
     }

    %flex-center-content {
         display: flex;
         align-items: center;
         justify-content: center;
     }

    .main {
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "main-header" "main-content" "main-footer";
        grid-template-rows: 10% 85% 5%;
        grid-template-columns: 1fr;
        overflow: hidden;
        margin:  0;

        .main-header {
            @extend %flex-center-content;
        }

        .main-content {
            grid-area: main-content;
            background-color: $bg-color;
            @extend %top-padding-width-height;
            overflow: hidden;
        }

        .main-footer{
            grid-area: main-footer;
            display: flex;
            justify-content: center;
            flex-direction: column;
            background-color: #f5f5f5;
        }
    }
</style>